import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Switch, Table, Tooltip } from "antd";
import axios from "axios";
// import MerchantLayout from "../../layout/MerchantLayout";
import {
  AuditOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  EditOutlined,
} from "@ant-design/icons";
// import MerchantProductConsumption from "./MerchantProductConsumption";
// import MerchantProductInfo from "./MerchantProductInfo";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import MerchantCreateProduct from "./MerchantCreateProduct";
import MerchantProductInfo from "./MerchantProductInfo";
import MerchantEditProduct from "./MerchantEditProduct";
// import MerchantLayout from "../../../layout/MerchantLayout";
// import NotificationSound from "./../../../../assets/notification6.mp3";
// import { useRef } from "react";
import MerchantCreateProductVariants from "./MerchantCreateProductVariants";
import MerchantEditProductVariants from "./MerchantEditProductVariants";

const MerchantProducts = ({ categoryList, subCategoryList, limit }) => {
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDrawerAddVariant, setOpenDrawerAddVariant] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [productInfoDrawer, setProductInfoDrawer] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [editDrawerVariant, setEditDrawerVariant] = useState(false);
  const { subscriptionDetails } = useContext(SubscriptionInfo);

  // const calculateAvailability = (data) => {
  //   var emptyArray = [];
  //   for (let i = 0; i < data.productsprodrawused.length; i++) {
  //     emptyArray.push(
  //       parseFloat(data.productsprodrawused[i].productsaverawproduct.quantity) /
  //         parseFloat(data.productsprodrawused[i].consumption)
  //     );
  //   }
  //   var min = Math.min.apply(Math, emptyArray);
  //   return parseInt(min).toFixed(0);
  // };

  // const audioPlayer = useRef(null);

  // function playAudio() {
  //   audioPlayer.current.play();
  // }

  const columns = [
    {
      title: "",
      dataIndex: "",
      ellipsis: true,
      width: 50,
      render: (text) => (
        <div>
          <Switch
            onChange={() =>
              onChangeProdStatus(parseInt(text.status), text.id, "products")
            }
            checked={Boolean(parseInt(text.status))}
            size="small"
          />
        </div>
      ),
    },
    {
      title: "Product",
      dataIndex: "product",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Purchase SRP",
      dataIndex: "purchase_srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "SRP",
      dataIndex: "srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },

    ...(Boolean(
      parseInt(
        subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
      )
    )
      ? [
          {
            title: "Available",
            dataIndex: "quantity",
            align: "center",
            // render: (text, record) => <p>{calculateAvailability(text)}</p>,
            render: (text, record) => (
              <p style={{ textAlign: "right" }}>{text}</p>
            ),
            visible: false,
          },
        ]
      : []),
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 160,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 160 }}>
          <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: parseInt(text.has_variant) === 1 ? 5 : 0 }}
            />
          </Tooltip>

          {/* {console.log("text: ", text)} */}
          {parseInt(text.has_variant) === 1 && (
            <Tooltip title="Add Product">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setOpenDrawerAddVariant(true);
                }}
                icon={<PlusOutlined />}
                style={{ marginRight: 5 }}
              />
            </Tooltip>
          )}
        </p>
      ),
    },
  ];

  const columns2 = [
    {
      title: "",
      dataIndex: "",
      ellipsis: true,
      width: 50,
      render: (text) => (
        <div>
          <Switch
            onChange={() =>
              onChangeProdStatus(parseInt(text.status), text.id, "variants")
            }
            checked={Boolean(parseInt(text.status))}
            size="small"
          />
        </div>
      ),
    },
    {
      title: "Variant",
      dataIndex: "product",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Purchase SRP",
      dataIndex: "purchase_srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "SRP",
      dataIndex: "srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 160,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 160 }}>
          <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawerVariant(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const tableColumns2 = columns2.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const onChangeProdStatus = (status, id, type) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", id);
    formdata.append("status", parseInt(status) === 1 ? 0 : 1);
    formdata.append("type", type);
    setLoading(true);
    axios
      .post("user/merchant/update-status-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated status successfully.");
          getProductList();
          setLoading(false);
        }
      })
      .catch((error) => {
        // console.log("Error: ", error);
        setLoading(false);
      });
  };

  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getProductList();
  }, [getProductList]);

  const searchable = productList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search"
              placeholder="Search product"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            // onClick={() => setSelectedTab("form")}
            onClick={() => setOpenDrawer(true)}
            disabled={productList.data.length >= parseInt(limit)}
          >
            Add Product
          </Button>
          {/* <Button
            type="primary"
            // icon={<PlusOutlined />}
            // onClick={() => setSelectedTab("form")}
            onClick={playAudio}
            // disabled={productList.data.length >= parseInt(limit)}
          >
            Play
          </Button>
          <audio ref={audioPlayer} src={NotificationSound} /> */}
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
          expandable={{
            expandedRowRender: (record) => (
              <div
              // style={{ margin: 0 }}
              >
                <Table
                  {...tableProps}
                  // pagination={{
                  //   position: ["bottomCenter"],
                  // }}
                  columns={tableColumns2}
                  dataSource={
                    record.productvariants.length > 0
                      ? record.productvariants
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record2) => record2.id}
                  // showHeader={false}
                  // showSorterTooltip={false}
                  pagination={false}
                />

                {/* {record.productvariants.length > 0 ? (
                  record.productvariants.map((data, index) => (
                    <div
                      key={index}
                      style={{
                        marginLeft: 40,
                        borderBottom: "1px solid #e5e5e5",
                        padding: 10,
                        display: "flex",
                      }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        <Switch
                          // onChange={() =>
                          //   onChangeProdStatus(parseInt(text.status), text.id)
                          // }
                          checked={Boolean(parseInt(data.status))}
                          size="small"
                          style={{ marginRight: 30 }}
                        />
                        {data.product} - {data.description}
                      </div>
                      <div>
                        <Tooltip title="Product Info">
                          <Button
                            type="dashed"
                            shape="circle"
                            onClick={() => {
                              setSelectedData(data);
                              setProductInfoDrawer(true);
                            }}
                            icon={<InfoCircleOutlined />}
                            style={{ marginRight: 5 }}
                          />
                        </Tooltip>

                        <Tooltip title="Edit">
                          <Button
                            type="dashed"
                            shape="circle"
                            // onClick={() => {
                            //   setSelectedData(text);
                            //   setEditDrawer(true);
                            // }}
                            icon={<EditOutlined />}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      color: "red",
                    }}
                  >
                    No variant found!
                  </div>
                )} */}
              </div>
            ),
            rowExpandable: (record) => parseInt(record.has_variant) === 1,
          }}
        />
      </div>

      {productInfoDrawer && (
        <MerchantProductInfo
          open={productInfoDrawer}
          close={() => setProductInfoDrawer(false)}
          selectedData={selectedData}
        />
      )}

      {openDrawer && (
        <MerchantCreateProduct
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getProductList={() => getProductList()}
          categoryList={categoryList}
          subCategoryList={subCategoryList}
          limit={limit}
        />
      )}

      {editDrawer && (
        <MerchantEditProduct
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getProductList={() => getProductList()}
          selectedData={selectedData}
          categoryList={categoryList}
          subCategoryList={subCategoryList}
        />
      )}

      {openDrawerAddVariant && (
        <MerchantCreateProductVariants
          open={openDrawerAddVariant}
          close={() => setOpenDrawerAddVariant(false)}
          setLoading={setLoading}
          getProductList={() => getProductList()}
          selectedData={selectedData}
          // categoryList={categoryList}
          // subCategoryList={subCategoryList}
          // limit={limit}
        />
      )}

      {editDrawerVariant && (
        <MerchantEditProductVariants
          open={editDrawerVariant}
          close={() => setEditDrawerVariant(false)}
          setLoading={setLoading}
          getProductList={() => getProductList()}
          selectedData={selectedData}
        />
      )}
    </>
  );
};

export default MerchantProducts;
